export const snakeCaseToCamelCase = (string) =>
  string
    .split('_')
    .map((word, index) =>
      index > 0
        ? `${word[0].toUpperCase()}${word.slice(1).toLowerCase()}`
        : word.toLowerCase(),
    )
    .join('');
